import { Stack } from '@mui/material'

import { ExportAdornment } from '@/components/ExportAdornment'

import { useController } from '../../hooks/useController'
import { MODAL_HEIGHT } from '../../constants'
import { Body } from './components/Body'

export function ConfigureFormat() {
  const {
    data: { format },
  } = useController()

  return (
    <Stack mx={-4} direction="row" height={MODAL_HEIGHT}>
      <Stack flex="1 1 auto">
        <Body />
      </Stack>

      <Stack
        flex="0 0 auto"
        sx={{
          [`& > *`]: {
            height: '100%',
          },
        }}
      >
        <ExportAdornment logo={format} />
      </Stack>
    </Stack>
  )
}
